import Image from 'next/image'

import { TileCaption, TileImage } from '@mc/design-system'

import styles from './SpecialTile.module.scss'

export interface SpecialTileProps {
  text: string
  desktopImageUrl: string
  mobileImageUrl: string
}

export const SpecialTile = ({
  text,
  desktopImageUrl,
  mobileImageUrl,
}: SpecialTileProps) => (
  <div className={styles.specialTile}>
    {/* Mobile & tablet image  */}
    <div className='d-block d-lg-none'>
      <TileImage
        className='mc-corners--md'
        image={<Image fill src={mobileImageUrl} alt={text} sizes='100vw' />}
      />
    </div>
    {/* Desktop image */}
    <div className='d-none d-lg-block'>
      <TileImage
        className='mc-corners--md'
        image={<Image fill src={desktopImageUrl} alt={text} sizes='50vw' />}
      />
    </div>
    <TileCaption className='mc-text-h4 mc-pb-2 mc-px-2' position='left bottom'>
      {text}
    </TileCaption>
  </div>
)
